import { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import { IconGraphy, Typography, colors } from '@leapeasy/ui-kit';

export const DetailsCard = ({
  title,
  value,
  width = '16.6%',
  direction = 'column',
  footnote,
  copyText,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    if (!copyText || !navigator.clipboard?.writeText) return;

    try {
      await navigator.clipboard.writeText(copyText);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }, [copyText]);

  return (
    <Box
      sx={{
        background: '#F9F8F9',
        border: `1px solid ${colors.black[200]}`,
      }}
      boxSizing="border-box"
      flexShrink={1}
      width={width}
      padding="8px 12px"
      gap="4px"
      borderRadius="8px"
      display="flex"
      flexDirection={direction}
    >
      <Box display="flex" alignItems="flex-start" justifyContent="space-between" gap="8px">
        <Typography variant="body2" style={{ fontWeight: '600', color: colors.purple[900] }}>
          {value}
        </Typography>
        {copyText ? (
          <Box
            component="button"
            type="button"
            aria-label={copied ? 'Copied check payee text' : 'Copy check payee for email'}
            onClick={handleCopy}
            sx={{
              border: 'none',
              background: 'transparent',
              padding: 0,
              cursor: 'pointer',
              flexShrink: 0,
              lineHeight: 0,
            }}
          >
            <IconGraphy
              icon="EditorLayout.CopyAll"
              width="16px"
              height="16px"
              color={copied ? colors.purple[700] : colors.neutral[700]}
            />
          </Box>
        ) : null}
      </Box>

      <Typography variant="body3" style={{ fontWeight: '500', color: colors.neutral[900] }}>
        {title}
      </Typography>

      {footnote ? (
        <Typography variant="body3" style={{ fontWeight: '400', color: colors.neutral[700] }}>
          {footnote}
        </Typography>
      ) : null}
    </Box>
  );
};
